import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// MARK://dhk8/ui/components/BarcodeInput
// Input scanner-friendly con symbology hints + audio beep via Web Audio API.
// Audio base64 WAV inline para no depender de archivos externos.
import { forwardRef, useCallback } from 'react';
import { ScanLine } from 'lucide-react';
// Tiny 440Hz beep (WAV, 0.1s, 8-bit PCM base64)
const SUCCESS_BEEP = (() => {
    if (typeof window === 'undefined')
        return null;
    try {
        const AudioCtx = window.AudioContext ?? window.webkitAudioContext;
        if (!AudioCtx)
            return null;
        return () => {
            const ctx = new AudioCtx();
            const osc = ctx.createOscillator();
            const gain = ctx.createGain();
            osc.connect(gain);
            gain.connect(ctx.destination);
            osc.type = 'sine';
            osc.frequency.setValueAtTime(880, ctx.currentTime);
            gain.gain.setValueAtTime(0.15, ctx.currentTime);
            gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.1);
            osc.start(ctx.currentTime);
            osc.stop(ctx.currentTime + 0.1);
        };
    }
    catch {
        return null;
    }
})();
const ERROR_BEEP = (() => {
    if (typeof window === 'undefined')
        return null;
    try {
        const AudioCtx = window.AudioContext ?? window.webkitAudioContext;
        if (!AudioCtx)
            return null;
        return () => {
            const ctx = new AudioCtx();
            const osc = ctx.createOscillator();
            const gain = ctx.createGain();
            osc.connect(gain);
            gain.connect(ctx.destination);
            osc.type = 'sine';
            osc.frequency.setValueAtTime(220, ctx.currentTime);
            gain.gain.setValueAtTime(0.15, ctx.currentTime);
            gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.2);
            osc.start(ctx.currentTime);
            osc.stop(ctx.currentTime + 0.2);
        };
    }
    catch {
        return null;
    }
})();
export const BarcodeInput = forwardRef(function BarcodeInput({ onBarcode, beepOnScan = true, beepOnError = false, invalid, className, symbologyHint = 'EAN-13, QR, Code128…', onKeyDown, ...props }, ref) {
    const handleKeyDown = useCallback((e) => {
        if (e.key === 'Enter') {
            const val = e.currentTarget.value.trim();
            if (val) {
                if (beepOnScan)
                    SUCCESS_BEEP?.();
                onBarcode?.(val);
            }
            else if (beepOnError) {
                ERROR_BEEP?.();
            }
        }
        onKeyDown?.(e);
    }, [onBarcode, beepOnScan, beepOnError, onKeyDown]);
    const classes = [
        'dhk8-input',
        invalid ? 'dhk8-input--error' : '',
        className ?? '',
    ].filter(Boolean).join(' ');
    return (_jsxs("div", { className: "dhk8-barcode-wrap", children: [_jsx("input", { ref: ref, type: "text", inputMode: "none", autoComplete: "off", autoCorrect: "off", spellCheck: false, className: classes, placeholder: props.placeholder ?? symbologyHint, onKeyDown: handleKeyDown, ...props }), _jsx("span", { className: "dhk8-barcode-wrap__icon", "aria-hidden": "true", children: _jsx(ScanLine, { size: 16 }) })] }));
});
//# sourceMappingURL=BarcodeInput.js.map